__turbopack_context__.v({
  "form": "PhoneCodeVerificationInput-module-scss-module__f1T9Xa__form",
  "verificationCodeError": "PhoneCodeVerificationInput-module-scss-module__f1T9Xa__verificationCodeError",
  "verificationTokenFormContainer": "PhoneCodeVerificationInput-module-scss-module__f1T9Xa__verificationTokenFormContainer",
  "verificationTokenFormContainerError": "PhoneCodeVerificationInput-module-scss-module__f1T9Xa__verificationTokenFormContainerError",
});
